import { Store } from 'src/store/index';
import isEmbroideryProduct from 'src/util/embroidery/isEmbroideryProduct';
import useIntegrationLayer from 'src/util/hook/useIntegrationLayer';
import getProductUid from './getProductUid';
import getInternalUid from './getInternalUid';

// Printing methods accepted by the public-catalog list endpoint (server-validated).
// Only embroidery is derivable on the host today; dtg/dtf are kept for completeness.
export enum PrintingMethod {
  DTG = 'dtg',
  DTF = 'dtf',
  Embroidery = 'embroidery',
}

const getPrintingMethod = (store: Store): PrintingMethod | undefined => {
  const integrationLayer = useIntegrationLayer();

  // Prefer the store (reflects mid-session product/method switches), and fall back
  // to the integration layer (populated at boot, before the store is hydrated by
  // the design-structure fetch). The `-emb` suffix can sit on either uid.
  const productUid = getProductUid(store) || integrationLayer.productUid;
  const internalUid = getInternalUid(store) || integrationLayer.internalUid;

  return isEmbroideryProduct(productUid || internalUid) ? PrintingMethod.Embroidery : undefined;
};

export default getPrintingMethod;
